/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import {
    DatalistAnagrafica,
    DocumentoProgetto,
    LeggiProgetto,
    Opera,
    Progetto
} from '@models';
import { ProgettoService } from '@shared/services/progetto.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-modifica-progetto',
    templateUrl: './modifica-progetto.component.html'
})
export class PagesGestioneProgettoModificaProgettoComponent implements OnInit {

    public criteriaForm: FormGroup;
    public datalist: DatalistAnagrafica;
    public progetto: Progetto;
    public leggiProgettoList: LeggiProgetto[] = [];
    public documentoProgettoList: DocumentoProgetto[] = [];
    public opereAssociateList: Opera[] = [];

    constructor(
        private progettoService: ProgettoService,
        private utilsService: UtilsService,
        private router: Router,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.datalist = this.route.snapshot.data['additionalInformation'].datalist;
        this.progetto = this.route.snapshot.data['additionalInformation'].progetto;
        this.leggiProgettoList = this.route.snapshot.data['additionalInformation'].leggiProgetto;
        this.documentoProgettoList = this.route.snapshot.data['additionalInformation'].documentoProgetto;
        this.opereAssociateList = this.route.snapshot.data['additionalInformation'].opereAssociate;
        this.criteriaForm = this.progettoService.generateFormProgetto(this.progetto);
    }

    public deleteProgetto() {
        this.progettoService.delete(this.progetto.idProgetto).subscribe(response => {
            if (this.utilsService.genericResponse204NoContent(response)) {
                this.router.navigate(['../..'], { relativeTo: this.route });
            }
        });
    }

    public save() {
        if (this.criteriaForm.invalid) {
            this.utilsService.showWarning(CoreI18nConfigs.messages.fieldRequired);
            this.criteriaForm.markAllAsTouched();
            return;
        }
        this.progettoService.update(this.criteriaForm.getRawValue()).subscribe(response => {
            this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
        });
    }

}
